import {
    isScanNotMentalTest,
    isScanOnlyWorkPreferences,
} from './ScanModulesDetection';
import { isIOSVersionAllowed } from './detect-mobile';
import { isDesktop } from './device-data';
import { APP_ENVIRONMENT } from './environment-variables';

export const checkAllowedModulesAndDevices = (
    scanModules,
    companySlug,
    targetGroupId,
) => {
    const isQuestionnaireOnlyScan = isScanOnlyWorkPreferences(scanModules);
    const isNotMentalTestScan = isScanNotMentalTest(scanModules);
    const isDesktopDevice = isDesktop();
    const isMobileIOSVersionAllowed = isIOSVersionAllowed();
    const allowedCompanies =
        APP_ENVIRONMENT !== 'PROD' ||
        companySlug === 'levelworksplatform' ||
        companySlug === 'neurolytics-test' ||
        companySlug === 'demo' ||
        companySlug === 'dev' ||
        (companySlug === 'hefwonen' &&
            targetGroupId === 'd900cb62-7287-4d1e-8370-689ccf786a4d') ||
        (companySlug === 'levelworksnl' &&
            (targetGroupId === '4998ac60-ec8c-437d-b7bc-bb487068e963' ||
                targetGroupId === 'b3cd15af-4945-405a-a084-f47f75a25a80' ||
                targetGroupId === '5c77f5f3-5f83-4353-bafa-eff74311109d'));
    return !!(
        isDesktopDevice ||
        isQuestionnaireOnlyScan ||
        (allowedCompanies && isMobileIOSVersionAllowed) ||
        (isNotMentalTestScan && isMobileIOSVersionAllowed)
    );
};
